<template>
  <div class="subject-card-wrapper">
    <v-card
      class="ns-card subject-card"
      :elevation="0"
      @click="openFolder"
    >
      <div class="subject-card-inner">
        <img
          class="subject-folder-image"
          alt="folder"
          src="../../assets/images/folder_image.png"
        >
        <div class="subject-card-title">
          {{ subject.subject_name }}
        </div>
      </div>
    </v-card>
    <v-btn
      class="delete-btn"
      size="x-small"
      variant="text"
      icon
      @click.stop="deleteSubject"
    >
      <i class="pi pi-trash" />
    </v-btn>
  </div>
</template>

<script>
  import { StorageService } from "@/services/StorageService";

  export default {
    name: "SubjectCard",
    props: {
      subject: {
        type: Object,
        required: true
      }
    },
    methods: {
      openFolder() {
        let data = { id: this.subject.id, is_sample: this.subject.is_sample }
        StorageService.saveSubjectContext(data.id, data.is_sample);
        this.$router.push({ name: "KnowledgeBase", params: data });
      },
      deleteSubject() {
        this.$emit('delete', this.subject.id);
      },
    },
  };
</script>

<style scoped>
.subject-card-wrapper {
  position: relative;
  width: 80px;
  display: inline-block;
}

.subject-card {
  width: 80px;
  padding: var(--space-2) !important;
  cursor: pointer;
}

.subject-card-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-1);
}

.subject-folder-image {
  width: 35px;
  height: 35px;
}

.subject-card-title {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  text-align: center;
  color: var(--color-text-primary);
  word-break: break-word;
}

.delete-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: var(--color-background-secondary);
  opacity: 0;
  transition: opacity 0.15s ease;
}

.subject-card-wrapper:hover .delete-btn,
.delete-btn:focus-visible {
  opacity: 1;
}

@media (hover: none) {
  .delete-btn {
    opacity: 1;
  }
}

.delete-btn:hover {
  background-color: var(--color-error);
  color: white;
}
</style>
